export default __webpack_public_path__ + "static/media/vehicle_sedan.ef04bf53.svg";